import { produce } from "immer";
import {
  FETCH_WEBENQUIRY,
  FETCH_WEBENQUIRY_FAILURE,
  FETCH_WEBENQUIRY_SUCCESS,
  //
  ADD_WEBENQUIRY,
  ADD_WEBENQUIRY_SUCCESS,
  ADD_WEBENQUIRY_FAILURE,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_SUCCESS,
  GET_VIEW_DATA_FAILURE,
  //
  EDIT_WEBENQUIRY,
  EDIT_WEBENQUIRY_SUCCESS,
  EDIT_WEBENQUIRY_FAILURE,
  //
  DELETE_WEBENQ,
  DELETE_WEBENQ_SUCCESS,
  DELETE_WEBENQ_FAILURE,
  //
  CONVERT_LEAD,
  CONVERT_LEAD_SUCCESS,
  CONVERT_LEAD_FAILURE,
  //
  TOGGLE_CONVERT,
  //
  GET_REPORT,
  GET_REPORT_SUCCESS,
  GET_REPORT_FAILURE,
  //
  GET_TYPE_REPORT,
  GET_TYPE_REPORT_SUCCESS,
  GET_TYPE_REPORT_FAILURE,
  //
  GET_REF_REPORT,
  GET_REF_REPORT_SUCCESS,
  GET_REF_REPORT_FAILURE,
  //
  SET_REPORT,
  //
  SET_DIGITAL_DATA,
  SET_RECOMM_DATA,
  SET_LOCAL_DATA,
  SET_ADVERT_DATA,
} from "./constants";

export const initialState = {
  isFetchingEnqs: false,
  webEnquiries: [],
  isAdding: false,
  isFetchingData: false,
  currentWebEnq: {},
  isUpdating: false,
  isDeleting: false,
  convertModal: {
    open: false,
    currentEnquiry: {},
  },
  isGeneratingReport: false,
  isGeneratingTypeReport: false,

  reportStage: {
    list: [],
    type: "default",
  },
  webEnqReport: [],
  typeReport: [],
  refReport: {},
  //
  digitalData: [],
  recommData: [],
  localData: [],
  advertData: [],
};

const WebsiteEnquiriesReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case FETCH_WEBENQUIRY:
        draft.isFetchingEnqs = true;
        draft.webEnquiries = [];
        break;
      case FETCH_WEBENQUIRY_SUCCESS:
        draft.isFetchingEnqs = false;
        draft.webEnquiries = action.payload;
        break;
      case FETCH_WEBENQUIRY_FAILURE:
        draft.isFetchingEnqs = false;
        draft.webEnquiries = [];
        break;

      case ADD_WEBENQUIRY:
        draft.isAdding = true;
        break;
      case ADD_WEBENQUIRY_SUCCESS:
        draft.isAdding = false;
        break;
      case ADD_WEBENQUIRY_FAILURE:
        draft.isAdding = false;
        break;

      case GET_VIEW_DATA:
        draft.isFetchingData = true;
        draft.currentWebEnq = {};
        break;
      case GET_VIEW_DATA_SUCCESS:
        draft.isFetchingData = false;
        draft.currentWebEnq = action.payload;
        break;
      case GET_VIEW_DATA_FAILURE:
        draft.isFetchingData = false;
        draft.currentWebEnq = {};
        break;

      case EDIT_WEBENQUIRY:
        draft.isUpdating = true;
        break;
      case EDIT_WEBENQUIRY_SUCCESS:
        draft.isUpdating = false;
        break;
      case EDIT_WEBENQUIRY_FAILURE:
        draft.isUpdating = false;
        break;

      case DELETE_WEBENQ:
        draft.isDeleting = true;
        break;
      case DELETE_WEBENQ_SUCCESS:
        draft.isDeleting = false;
        break;
      case DELETE_WEBENQ_FAILURE:
        draft.isDeleting = false;
        break;

      case CONVERT_LEAD:
        draft.isConverting = true;
        break;
      case CONVERT_LEAD_SUCCESS:
        draft.isConverting = false;
        break;
      case CONVERT_LEAD_FAILURE:
        draft.isConverting = false;
        break;

      case TOGGLE_CONVERT:
        draft.convertModal = action.payload;
        break;

      case GET_REPORT:
        draft.isGeneratingReport = true;
        draft.webEnqReport = [];
        draft.refReport = {};
        draft.reportStage = {
          list: [],
          type: "default",
        };
        break;
      case GET_REPORT_SUCCESS:
        draft.isGeneratingReport = false;
        draft.webEnqReport = action.payload;
        break;
      case GET_REPORT_FAILURE:
        draft.isGeneratingReport = false;
        draft.webEnqReport = [];
        break;

      case GET_TYPE_REPORT:
        draft.isGeneratingTypeReport = true;
        draft.typeReport = [];
        draft.refReport = {};
        draft.reportStage = {
          list: [],
          type: "default",
        };
        break;
      case GET_TYPE_REPORT_SUCCESS:
        draft.isGeneratingTypeReport = false;
        draft.typeReport = action.payload;
        break;
      case GET_TYPE_REPORT_FAILURE:
        draft.isGeneratingTypeReport = false;
        draft.typeReport = [];
        break;

      case GET_REF_REPORT:
        draft.isGettingRef = true;
        break;
      case GET_REF_REPORT_SUCCESS:
        draft.isGettingRef = false;
        draft.refReport = action.payload;
        break;
      case GET_REF_REPORT_FAILURE:
        draft.isGettingRef = false;
        break;

      case SET_REPORT:
        draft.reportStage = action.payload;
        break;

      case SET_DIGITAL_DATA:
        draft.digitalData = action.payload;
        break;
      case SET_RECOMM_DATA:
        draft.recommData = action.payload;
        break;
      case SET_LOCAL_DATA:
        draft.localData = action.payload;
        break;
      case SET_ADVERT_DATA:
        draft.advertData = action.payload;
        break;

      default:
        return state;
    }
  });

export default WebsiteEnquiriesReducer;
